const PASSFORM_NAMES = ['passform'];

class SizeFitting extends HTMLElement {
  constructor() {
    super();
    this._abortController = null;
  }

  connectedCallback() {
    this.loadRating();
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  _hide() {
    this.setAttribute('hidden', '');
  }

  _setRating(rating) {
    const ratingInBounds = Math.min(5, Math.max(1, Number(rating)));
    this.style.setProperty('--size-fitting-rating', String(ratingInBounds));
  }

  _show() {
    this.removeAttribute('hidden');
  }

  async loadRating() {
    this._abortController?.abort();
    const sku = (this.dataset.sku || '').trim();
    const store = (this.dataset.store || 'www.smilodox.com').trim();

    if (!sku) return;

    const controller = new AbortController();
    this._abortController = controller;

    const url = `https://api.reviews.io/product/review?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}`;

    try {
      const response = await fetch(url, {
        signal: controller.signal,
        headers: { Accept: 'application/json' },
      });

      if (!response.ok)  return;

      const data = await response.json();
      const ratings = Array.isArray(data?.ratings) ? data.ratings : [];
      
      const passformRating = ratings.find((rating) => {
        const text = String(rating?.rating_text || '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/\p{M}/gu, '');
        return PASSFORM_NAMES.includes(text);
      });

      const avgPassformRating = passformRating?.average_rating;
      if (avgPassformRating == null || Number.isNaN(Number(avgPassformRating))) return;
      
      this._setRating(Number(avgPassformRating));
      this._show();
    } catch (e) {
      if (e.name === 'AbortError') return;
      this._hide();
    }
  }
}

if (!customElements.get('size-fitting')) {
  customElements.define('size-fitting', SizeFitting);
}
